var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.params.value)?_c('vs-chip',{staticClass:"ag-grid-cell-chip",attrs:{"color":_vm.chipColor(_vm.params.value)}},[_c('feather-icon',{attrs:{"icon":_vm.chipIcon(_vm.params.value),"svgClasses":"h-5 w-5 mr-1"}}),_c('span',[_vm._v(" "+_vm._s(_vm.$t(`$CampaignsModules.$CampaignDetailsStatus.${_vm.params.value}`))+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }